class LqdFancyHeadingHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);
    
    this.handleDestroy();

    this.initSplitText();
    this.initTextRotator();
    this.initInView();

  }
  
  getDefaultSettings() {
    return {
      selectors: {
        splitTextElement: '[data-split-text]',
        textRotatorElement: '[data-text-rotator]',
        inViewElement: '[data-inview]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $splitTextElement: this.$element.find(selectors.splitTextElement),
      $textRotatorElement: this.$element.find(selectors.textRotatorElement),
      $inViewElement: this.$element.find(selectors.inViewElement),
    }
  }

  initSplitText() {

    this.elements.$splitTextElement.liquidSplitText();

  }

  initCustomAnimation() {

    this.elements.$customAnimationElement.liquidCustomAnimations();

  }

  initTextRotator() {

    this.elements.$textRotatorElement.liquidTextRotator();

  }

  initInView() {

    this.elements.$inViewElement.liquidInView();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleSplitTextDestroy();
    this.handleTextRotatorDestroy();

  }

  handleSplitTextDestroy() {

    if ( ! this.elements.$splitTextElement.length ) return;

    const splitTextData = this.elements.$splitTextElement.data('plugin_liquidSplitText');

    if ( splitTextData ) {
      splitTextData.destroy();
    }

  }

  handleTextRotatorDestroy() {

    if ( ! this.elements.$textRotatorElement.length ) return;

    const textRotatorData = this.elements.$textRotatorElement.data('plugin_liquidTextRotator');

    if ( textRotatorData ) {
      textRotatorData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdFancyHeadingHandler, { $element } );
};